import { Box, CssBaseline, ThemeProvider, createTheme, useMediaQuery } from "@mui/material";
import { SideMenu } from "../molecules/sidemenu/SideMenu";
import Header from "../molecules/Header";
import { useCallback, useEffect, useState } from "react";
import Main from "../molecules/Main";

/** レイアウト コンポーネント */
const HaccpLayout = ({ children }) => {
    // メニューを開くかどうかの判定値
    const [open, setOpen] = useState(false);

    /** Mui Theme */
    const theme = createTheme({
        palette: {
            errorCell: {
                main: "#FFEBEE",
            },
        },
        components: {
            MuiTextField: {
                defaultProps: {
                    size: 'small',
                    variant: 'outlined',
                },
                styleOverrides: {
                    root: {
                        minWidth: "max-content"
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        whiteSpace: "nowrap",
                        minWidth: "max-content"
                    }
                }
            }
        }
    });

    /** メニューを閉じるかどうかの判定値 */
    const shouldMenuClosed = !useMediaQuery(theme.breakpoints.up('sm'));

    /** メニューを閉じる */
    const closeMenu = useCallback(() => {
        if (!open) return;
        setOpen(false)
    }, [open]);

    /** メニューアイコンをクリックするとき イベントハンドラ */
    const onClickMenuIcon = useCallback(() => setOpen(!open), [open]);

    // Webアプリの横幅が一定まで狭まっていたらメニューを閉じる
    useEffect(() => {
        if (!shouldMenuClosed) return;
        closeMenu();
    }, [closeMenu, shouldMenuClosed]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box display="flex">
                <Header open={open} onClick={onClickMenuIcon} />
                <SideMenu open={open} />
                <Main open={open}>
                    {children}
                </Main>
            </Box>
        </ThemeProvider>
    );
};

export default HaccpLayout;
